import { list } from "postcss";

export const translations = {
	diabloSeries: {
		h1_title: {
			en: "DIABLO SERIES",
			fr: "SÉRIE DIABLO",
		},
		h2_choose_your_model: {
			en: "Choose your model",
			fr: "Choisissez votre modèle",
		},
		diabloSeries_list: {
			en: [
				"4-wheel disc brakes",
				"Bluetooth touch screen",
				"Led lights",
				"Seatbelts",
				"48V acid battery",
				"Electric parking brake",
				"Rear view camera",
				"14 inch wheel",
				"Integrated charger",
				"Trunk",
				"Controller Curtis 400A",
				"Turn signal, stop light, fog light",
				"Possibility of running boards",
				"Cooler"
			],
			fr: [
				"Freins à disque 4 roues",
				"Écran tactile Bluetooth",
				"Lumières LED",
				"Ceintures de sécurité",
				"Batterie acide 48V",
				"Frein de stationnement électrique",
				"Caméra de recul",
				"Roue de 14 pouces",
				"Chargeur intégré",
				"Coffre arrière",
				"Contrôleur Curtis 400A",
				"Clignotant, feu d'arrêt, lumière antibrouillard",
				"Possibilité de marchepieds",
                "Glacière"
			],
		},
		h3_colorPicker: {
			en: "Color Options",
			fr: "Options de couleur",
		},
		p_colorPicker: {
			en: "*Please note that due to variations between screens, actual colors may vary. Check with your dealer for actual colors.",
			fr: "*Veuillez noter qu'en raison des variations entre les écrans, les couleurs réelles peuvent varier. Vérifiez auprès de votre revendeur les couleurs réelles.",
		},
		p_touch_screen_compatible: {
			en: "Touchscreen compatible with Apple Carplay & Android Auto",
			fr: "Écran tactile compatible avec Apple Carplay & Android Auto",
		},
		p_touch_screen_aftermarks: {		
			en: "Apple CarPlay and Android Auto are aftermarket features, not included as part of the golf car's factory-installed products. Dealers may specify or offer these features separately. Additional fees may apply. Please check with your local dealer for details",
			fr: "Apple CarPlay et Android Auto sont des fonctionnalités après-vente, non incluses dans les produits installés en usine de la voiturette de golf. Les concessionnaires peuvent spécifier ou offrir ces fonctionnalités séparément. Des frais supplémentaires peuvent s'appliquer. Veuillez vérifier auprès de votre revendeur local pour plus de détails",
		},
		h2_span_discover: {
			en: "EXPLORE DIABLO SERIES",
			fr: "EXPLOREZ LA SÉRIE DIABLO",
		},
		h2_discover: {
			en: "Discover the comfort and innovation",
			fr: "Découvrez le confort et l'innovation",
		},
		h2_discoverNext: {
			en: "of our carts.",
			fr: "de nos voiturettes.",
		},
		p_discover: {
			en: "The Diablo Series offers a range of high-performance electric vehicles designed for both urban and off-road adventures. With cutting-edge technology and sleek designs, the Luxor Series is perfect for those who seek both style and functionality.",
			fr: "La série Diablo propose une gamme de véhicules électriques de haute performance conçus pour les aventures urbaines et tout-terrain. Avec une technologie de pointe et des designs élégants, la série Thor est parfaite pour ceux qui recherchent à la fois style et fonctionnalité.",
		},
		t_features_screen: {
			en: "9 INCH SCREEN",
			fr: "ÉCRAN DE 9 POUCES",
		},
		p_features_screen: {
			en: "The screen of our carts offers various useful features you can find information on speed, battery status, distance traveled and bluetooth connections to make phone calls or listen to music.",
			fr: "L'écran de nos voiturettes offre diverses fonctionnalités utiles. Vous pouvez y trouver des informations sur la vitesse, l'état de la batterie, la distance parcourue et les connexions Bluetooth pour passer des appels téléphoniques ou écouter de la musique.",
		},
		t_features_rear_seats: {
			en: "REAR PLATFORM SEATS",
			fr: "SIÈGES DE PLATEFORME ARRIÈRE",
		},
		p_features_rear_seats: {
			en: "Our rear seats fold down to become a platform with an integrated trunk for added convenience.",
			fr: "Nos sièges arrière se rabattent pour devenir une plateforme avec un coffre intégré pour plus de commodité.",
		},
		t_features_seats: {
			en: "SEAT",
			fr: "SIÈGE",
		},
		p_features_seats: {
			en: "Our seats are padded with high quality materials. In summary, the seats of our carts are designed to offer superior comfort during your journeys.",
			fr: "Nos sièges sont rembourrés avec des matériaux de haute qualité. En résumé, les sièges de nos voiturettes sont conçus pour offrir un confort supérieur lors de vos déplacements.",
		},
		t_features_tires: {
			en: "TIRES AND WHEELS",
			fr: "PNEUS ET ROUES",
		},
		p_features_tires: {
			en: "The 14-inch tires and wheels of a cart offer a perfect balance between performance, comfort, and aesthetics. With their ideal size.",
			fr: "Les pneus et roues de 14 pouces d'une voiturette offrent un équilibre parfait entre performance, confort et esthétique. Avec leur taille idéale.",
		},
		t_features_cooler: {
			en: "COOLER",
			fr: "GLACIÈRE",
		},
		p_features_cooler: {
			en: "Our carts are equipped with a cooler that is really practical for the journey.",
			fr: "Nos voiturettes sont équipées d'une glacière qui est vraiment pratique pour le voyage.",
		},
		t_features_suspension: {
			en: "SUSPENSION",
			fr: "SUSPENSION",
		},
		p_features_suspension: {
			en: "The suspension is designed to provide optimal comfort when driving; it is specially designed to absorb the irregularities of the terrain, thus providing a more stable ride.",
			fr: "La suspension est conçue pour offrir un confort optimal lors de la conduite; elle est spécialement conçue pour absorber les irrégularités du terrain, offrant ainsi une conduite plus stable.",
		},
		h2_spec_title: {
			en: "SPECIFICATIONS",
			fr: "SPÉCIFICATIONS",
		},
		h3_spec_dimensions: {
			en: "DIMENSIONS",
			fr: "DIMENSIONS",
		},
		h3_spec_power: {
			en: "POWER",
			fr: "PUISSANCE",
		},
		h3_spec_features: {
			en: "FEATURES",
			fr: "FONCTIONNALITÉS",
		},
		list_spec_power: {
			en: [
				"6 8V lead acid batteries 48V",
				"4 KW motor",
				"400 A, AC controller",
				"Integrated 25 A charger",
				"Maximum speed 30 km/h"
			],
			fr: [
				"6 8V lead acid batteries 48V",
				"4 KW motor",
				"Contrôleur 400 A, AC",
				"Chargeur intégré 25 A",
				"Vitesse maximale 30 km/h"
			],
		},
		list_spec_features: {
			en: [
				"Double wishbone suspension for a smooth, quality ride feel",
				"Decorative strip",
				"Colorful decorative hubcaps",
				"Dashboard with color-matched cup holder insert",
				"Luxury steering wheel",
				"Rearview mirror",
				"EM brake",
				"LED lighting",
				"Turn signal, stop light",
				"USB charging ports",
				"Aluminum cargo box (Tilting, with pneumatic shock absorbers)",
				"14×7” Aluminum Wheel/ 23×10-14 Silent Tire with Off-road Thread",
				"Transparent folding windshield",
				"9” Multi-functional Touchscreen",
			],
			fr: [
				"Suspension à double triangulation pour une conduite douce et de qualité",
				"Bande décorative",
				"Enjoliveurs décoratifs colorés",
				"Tableau de bord avec insert de porte-gobelet assorti à la couleur",
				"Volant de luxe",
				"Rétroviseur",
				"Frein EM",
				"Éclairage LED",
				"Clignotant, feu d'arrêt",
				"Ports de charge USB",
				"Boîte de chargement en aluminium (basculante, avec amortisseurs pneumatiques)",
				"Roue en aluminium 14×7”/ Pneu silencieux 23×10-14 avec filetage tout-terrain",
				"Pare-brise pliant transparent",
				"Écran tactile multifonctionnel 9”",
			],
		},
		h2_shrink_charger: {
			en: "CHARGING PLUG",	
			fr: "PRISE DE CHARGE",
		},
		p_shrink_charger: {
			en: "Charge your battery with this integrated charger.",
			fr: "Chargez votre batterie avec ce chargeur intégré.",
		},
		h2_shrink_Ledlight: {
			en: "LED LIGHTS",
			fr: "LUMIÈRES LED",
		},
		p_shrink_cupHolders: {
			en: "Keep your drinks secure with these cup holders.",
			fr: "Gardez vos boissons en sécurité avec ces porte-gobelets.",
		},
		h2_shrink_dashStorage: {
			en: "DASHBOARD",
			fr: "TABLEAU DE BORD",
		},
		p_shrink_dashStorage: {
			en: "Store your items conveniently on the dashboard.",
			fr: "Rangez vos articles commodément sur le tableau de bord.",
		},
		h2_shrink_storage: {
			en: "STORAGE",
			fr: "RANGEMENT",
		},
		p_shrink_storage: {
			en: "Ample storage space for all your needs.",
			fr: "Un espace de rangement ample pour tous vos besoins.",
		},
		h2_shrink_usbPorts: {
			en: "USB PORTS",
			fr: "PORTS USB",
		},
		p_shrink_usbPorts: {
			en: "Charge your devices with multiple USB ports.",
			fr: "Chargez vos appareils avec plusieurs ports USB.",
		},
		h2_shrink_BackupCam: {
			en: "BACKUP CAMERA",
            fr: "CAMÉRA DE RECUL",
		},
		p_shrink_mirrorFlashers: {
			en: "Powered Rear View mirrors with turn signal indicator lights",
			fr: "Miroirs de vue arrière électriques avec clignotants",
		},
		h2_shrink_storageCompartment: {
			en: "STORAGE COMPARTMENT",
			fr: "COMPARTIMENT DE RANGEMENT",
		},
		p_shrink_storageCompartment: {
			en: "Extra easy-access storage compartment in the dashboard",
			fr: "Compartiment de rangement supplémentaire facile d'accès sur le tableau de bord",
		},
		h2_shrink_soundBar: {
			en: "SOUND BAR",
			fr: "BARRE DE SON",
		},
		p_shrink_soundBar: {
			en: "Wirelessly connect to the screen with adjustable lighting modes and LED lights",
			fr: "Connectez-vous sans fil à l'écran avec des modes d'éclairage réglables et des lumières LED",
		},
		h2_shrink_handles: {
			en: "CEILING HANDLE",
			fr: "POIGNÉE DE PLAFOND",
		},
		p_shrink_handles: {
			en: "Provides ergonomic support for your cantilevered elbows",
			fr: "Fournit un support ergonomique pour vos coudes en porte-à-faux",
		},
	},
} as const;

type TranslationKeys = typeof translations.diabloSeries.h1_title;
export type Language = keyof TranslationKeys;
